import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface ThreeLineCardSkeletonProps {
  cardsCount: number;
}

const ThreeLineCardSkeleton: React.FC<ThreeLineCardSkeletonProps> = ({
  cardsCount,
}) => {
  const arr = Array(cardsCount).fill(0);

  return (
    <>
      {arr.map((_, i) => (
        <div className="card-card-skeleton--three-line" key={i}>
          <h3>
            <Skeleton />
          </h3>
          <div>
            <Skeleton />
          </div>
          <div>
            <Skeleton />
          </div>
        </div>
      ))}
    </>
  );
};

export default ThreeLineCardSkeleton;
